import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, CategoriaSuterh, SearchCategoriaSuterhRequest, SearchCategoriaSuterhResponse, SaveCategoriaSuterhDto } from "../model/index";
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

@Injectable({
  providedIn: 'root'
})
export class CategoriaSuterhService extends CrudService<CategoriaSuterh, number, SaveCategoriaSuterhDto, SearchCategoriaSuterhRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'categoriaSuterh', sharedFunctions);

  }
}